import { Component, Input, OnInit } from '@angular/core';
import { util } from '../../../../shared/util';
import { IBPProfile } from '../../../../../type_definitions/datatypes';
import { STATE_BPWIZARD_GENERAL } from '../../../../shared/app-states';
import { BPProfilesDataService, IBPWizardProgress } from '../../bp-profiles-data.service';
import { BPProfilesService } from '../../bp-profiles.service';
import { ContactDataService } from '../../../../shared/contact/contact-data.service';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'bp-wizard-thank-you',
  template: `
    <div *ngIf="profileId">
      <h2 *ngIf="loading"><activity-indicator [useDefaultText]="true"></activity-indicator></h2>

      <div *ngIf="!loading">
        <h2><text key="HEADING"></text></h2>
        <text *ngIf="progress === 100" key="CONTENT"></text>
        <text *ngIf="progress < 100" key="CONTENT_INCOMPLETE"></text>

        <div *ngIf="pssContact">
          <p>{{ pssContact }}</p>
          <p><img [src]="pssContactPictureUrl" [alt]="pssContact" [title]="pssContact" (error)="errorImageHandler()" *ngIf="showImage"/></p>
        </div>

        <div class="double-space-top" *ngIf="progress < 100">
          <button *ngIf="progress < 100" class="btn btn-default btn-sm" type="button" (click)="goBack()">
            <i class="fa fa-caret-left"></i>&nbsp; <span translate>GA.BUTTONS.GO_BACK</span>
          </button>
        </div>
      </div>
    </div>
  `
})
export class BPWizardThankYouComponent implements OnInit {
  @Input() public profileId:number;
  public progress:number;
  public pssContact:string;
  public pssContactPictureUrl:string;
  public loading:boolean;
  public showImage:boolean = true;

  constructor(
    private stateService:StateService,
    private contactDataService:ContactDataService,
    private formattingService:FormattingService,
    private bpProfilesDataService:BPProfilesDataService,
    private bpProfilesService:BPProfilesService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.bpProfilesService.activeProfile = { id: this.profileId };
    this.loadData();
  }

  private loadData() {
    this.loading = true;

    Promise.all([
      this.bpProfilesService.loadProfileDetails(),
      this.bpProfilesDataService.getProfileProgress(this.bpProfilesService.activeProfile?.id)
    ])
      .then(util.spread((profileDetail:IBPProfile, progressParams:IBPWizardProgress) => {
        this.progress = progressParams.progress;
        this.pssContact = this.formattingService.formatContact(profileDetail.pss);
        this.pssContactPictureUrl = this.contactDataService.getContactPictureUrl(profileDetail.pss?.id);
      }))
      .finally(() => {
        this.loading = false;
      });
  }

  public goBack():void {
    this.stateService.go(STATE_BPWIZARD_GENERAL, { profileId: this.profileId });
  }

  public errorImageHandler():void {
    this.showImage = false;
  }
}